<template>
    <div class="employee-tab-inner">
        <b-overlay :show="showoverlay" rounded="sm">
            <div class="payroll-reporting-tab" id="nav-tabContent-intro" v-if="$acl['pf/leaverlist'] > 0">

                <b-tabs content-class="mt-3 reports-tab pb-4" nav-wrapper-class=" reports-tab-nav">
                    <b-tab active lazy>
                        <template #title>
                            <div
                                class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="pageurl + '/images/Leaver(s).png'"
                                    class="light-mode-icon" />
                                <h5>View Leaver(s)</h5>
                                <p>List of all Former Members of Provident Fund</p>
                                <b-button class="btn btn-primary">View</b-button> <!-- Mustafijur: 23-05-2026: View Report to View -->
                            </div>
                        </template>

                        <div class="">
                            <template v-if="$acl['pf/leaverlist'] > 1">
                                <pf-dereg-leaver-list :pageurl="this.$api_url" is_action="1"></pf-dereg-leaver-list>
                            </template>
                            <template v-else>
                                <pf-dereg-leaver-list :pageurl="this.$api_url" is_action="0"></pf-dereg-leaver-list>
                            </template>

                        </div>
                    </b-tab>
                    <b-tab lazy>
                        <template #title>

                            <div
                                class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="pageurl + '/images/De-Registration.png'"
                                    class="light-mode-icon" />
                                <h5>Manual De-Registration</h5>
                                <p>Deregister emplyees from the Provident Fund Manually.</p>
                                <b-button class="btn btn-primary">View</b-button> <!-- Mustafijur: 23-05-2026: View Report to View -->
                            </div>

                        </template>

                        <div class="">
                            <template v-if="$acl['pf/leaverlist'] > 1">
                                <pf-dereg-manual :pageurl="this.$api_url" is_action="1"></pf-dereg-manual>
                            </template>
                            <template v-else>
                                <pf-dereg-manual :pageurl="this.$api_url" is_action="0"></pf-dereg-manual>
                            </template>

                        </div>
                    </b-tab>


                </b-tabs>


            </div>
        </b-overlay>
    </div>
</template>
<script>
export default{
    props: ['flg','pageurl'],
    data(){
        return {
            dreg_show:1,
            showoverlay:false,
        }
    },
}
</script>
